export default "__VITE_ASSET__416e2344__"